export default "__VITE_ASSET__DFMmixAV__"